import React from 'react';

import CustomModal from 'components/CustomModal/CustomModal';

import { Button } from 'components/Button';

import { SkippedRecipient } from 'utils/api/modules/entities/entities.types';

import SkippedRecipientsList from './SkippedRecipientsList';

interface SendResultModalProps {
  open: boolean;
  total: number;
  skipped: SkippedRecipient[];
  onContinue: () => void;
}

// The backend returns `skipped` only on the 201 and never persists it, so this modal is the one
// chance to name a dropped recipient — a toast would take it away after five seconds.
const SendResultModal: React.FunctionComponent<SendResultModalProps> = ({ open, total, skipped, onContinue }) => {
  const continueRef = React.useRef<HTMLButtonElement>(null);

  React.useEffect(() => {
    if (open) {
      continueRef.current?.focus();
    }
  }, [open]);

  const count = skipped.length;

  return (
    <CustomModal
      openModal={open}
      disableClose
      modalTitle="Request sent"
      modalDescription={`Sent to ${total} recipient${total === 1 ? '' : 's'}. ${count} ${
        count === 1 ? 'was' : 'were'
      } not included:`}
      submitButton={
        <Button ref={continueRef} variant="contained" size="large" onClick={onContinue}>
          Continue
        </Button>
      }
    >
      <SkippedRecipientsList skipped={skipped} />
    </CustomModal>
  );
};

export default SendResultModal;
